import http from 'hub-http/clients/apiClient';
import { OBJECT_NAMES } from 'audiences-data/constants/crm';
import { CRM_USAGES_URL } from 'audiences-data/constants/urls';
export const AUDIENCE_USAGE_STATISTICS_URL = `${CRM_USAGES_URL}/${OBJECT_NAMES.AUDIENCE}/parents/statistics`;
export const AUDIENCE_USAGES_FOR_PARENT_TYPES_QUERY_LIMIT = 10;
export const getAudienceUsageStatistics = () => http.get(AUDIENCE_USAGE_STATISTICS_URL);
export const getAudienceUsagesForParentType = (crmAudienceId, parentType, offset) => http.post(`${CRM_USAGES_URL}/${OBJECT_NAMES.AUDIENCE}/${crmAudienceId}/parents-of-types/page`, {
  query: {
    includeLabels: true,
    limit: AUDIENCE_USAGES_FOR_PARENT_TYPES_QUERY_LIMIT,
    offset
  },
  data: {
    parentTypes: [parentType]
  }
});